
  import ModalDialog from "@/components/ModalDialog.vue";
  import {defineComponent, reactive, toRefs} from "vue";
  import {CostCenter} from "@/model/CostCenter";
  import CostCenterService from "@/service/CostCenterService";
  import PageUtils from "@/components/PageUtils";
  import OrderServiceV2 from "@/service/OrderServiceV2";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import {t} from "@/mixin/mixins";

  export default defineComponent({
    name: "OrderInfoCostCenterDialog",
    components: {
      ModalDialog
    },
    setup(props, context) {

      const initialState = {
        dialog: false,
        model: null as unknown as CostCenter,
        orderId: null as unknown as number,
        loading: false,
        items: new Array<CostCenter>(),
        search: "",
        result: (updated: boolean | PromiseLike<boolean>) => {
        }
      };

      const state = reactive({...initialState});

      const resetState = () => {
        Object.assign(state, initialState);
      };

      const close = () => {
        state.dialog = false;
        state.result(false);
        resetState();
      };

      const open = (orderId: number, costCenter: CostCenter | undefined | null) => {
        resetState();
        state.dialog = true;
        state.model = costCenter ? costCenter : null as unknown as CostCenter;
        state.orderId = orderId;

        state.loading = true;
        CostCenterService.getCostCenters()
          .then(response => {
            state.items = PageUtils.extractCollection(response.data, "costCenters");

          })
          .finally(() => state.loading = false);

        return new Promise<boolean>((resolve, reject) => {
          state.result = resolve;
        });
      };

      const save = () => {
        let request = {
          "costCenterId": state.model ? state.model.id : null
        };

        OrderServiceV2.updateOrder(state.orderId, request)
          .then(response => {
            state.dialog = false;
            state.result(true);
            resetState();
          })
          .catch(error => {
            eventBus.$emit(MessageTypes.ERROR, t("errors.generalError"));
          });
      };

      const costCenterSelected = (costCenter: CostCenter) => {
        state.model = costCenter;
      };

      const itemText = (item: CostCenter) => {
        if (item) {
          return item.name + " (" + item.costCenter + ")";
        } else {
          return null;
        }
      };

      return {...toRefs(state), itemText, costCenterSelected, close, open, save};
    }
  });
